import DefaultSignupStrategy from './defaultSignupStrategy';

const logo = require('../../../../../assets/images/brooks.jpg');

export default class BrooksSignupStrategy extends DefaultSignupStrategy {
  constructor() {
    super();

    this.isDefault = false;
    this.hasLogo = false;
    this.logo = '';
    this.logoAltText = '';
    this.pageClass = 'col-8 card card-signup brooks';
    this.header = 'Welcome Brooks Product Testers!';
    this.headline = `You are receiving a free 90 day trial of PWR Lab, courtesy of Brooks.
        PWR Lab is an easy-to-use but immensely powerful tool for enhancing your
        training and reducing your risk of injury. Sign up, sync your Garmin or Suunto
        watch, and get started!<br/><br/>Please register with the same email address
        you used for Brooks Product Testing`;

    this.showCoupon = false;
    this.pageStyle = 'margin-top: 20vw !important;';
    this.h3Style = 'margin-bottom: 20px;';
    this.rootStyle = `
      background-image: url(${logo});
      background-size: cover;
      min-height: 120vh;
      background-attachment: initial;
      overflow-y: initial;
  `.replace(/\n/g, '');
  }
}
